module.exports = __webpack_public_path__ + "img/step_4.f7d744d6.png";